import request from '@/utils/request';
import newRequest from '@/utils/new-request';
import qs from 'qs';

const baseFinanceURL = process.env.VUE_APP_FINANCE; // 财务系统接口地址

const baseURLAdmin = process.env.VUE_APP_ADMIN;
// --------------------------- 应收报价管理 start ---------------------------

// 报价分页查询
export const apiOfferPricePage = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/offerPrice/page',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 报价管理启用禁用
export const apiOfferPriceSwitch = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/offerPrice/switch',
    data: qs.stringify(data),
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 报价操作日志
export const apiOfferPriceOperateLog = (data, isBool = true) => {
  return newRequest({
    method: 'GET',
    url: '/offerPriceOperateLog/listByOfferPriceId/' + data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 获取报价方案详情
export const apiOfferPriceDetail = (data, isBool = true) => {
  return newRequest({
    method: 'GET',
    url: '/offerPriceDetail/listByOfferPriceId/' + data,
    isLoading: isBool // 是否显示加载中参数
  });
};
// 应收报价详情（新）
export const apiNewOfferPriceDetail = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/offerPriceDetail/listByOfferPriceIdAndPartitionId',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 新增报价
export const apiOfferPriceAdd = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/offerPriceDetail/add',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 编辑报价
export const apiOfferPriceDetailEdit = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/offerPriceDetail/edit',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 新增折扣系数
export const offerPriceDiscountAdd = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/offerPriceDiscount/add',
    data,
    isLoading: isBool
  });
};
// 编辑
export const offerPriceDiscountEdit = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/offerPriceDiscount/edit',
    data,
    isLoading: isBool
  });
};
// 删除
export const offerPriceDiscountDelete = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/offerPriceDiscount/delete',
    data,
    isLoading: isBool
  });
};
// 禁用
export const offerPriceDiscountDisable = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/offerPriceDiscount/disable',
    data,
    isLoading: isBool
  });
};
// 导出
export const offerPriceDiscountExport = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/offerPriceDiscount/export',
    data,
    isLoading: isBool
  });
};
// 分页查询
export const offerPriceDiscountPage = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/offerPriceDiscount/page',
    data,
    isLoading: isBool
  });
};

// --------------------------- 应收报价管理 end ---------------------------

// 应收主体（服务商/供应商）分页
export const apiProviderPage = (data, isBool = true) => {
  return request({
    method: 'POST',
    url: '/provider/page',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseURLAdmin
  });
};

// 获取报价方案其他规则
export const apiListByOfferPriceId = (data, isBool = true) => {
  return newRequest({
    method: 'GET',
    url: '/offerPriceOtherRules/listByOfferPriceId/' + data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 查询其他费用规则接口   报价界面使用
export const apilistByOfferPriceId = (ids) => {
  return newRequest({
    method: 'GET',
    url: '/payableOfferPriceOtherRules/listByOfferPriceId/' + ids,
    isLoading: true // 是否显示加载中参数
  });
};

// 获取报价方案其他规则(新)
export const apiNewListByOfferPriceId = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/offerPriceOtherRules/listByOfferPriceIdAndPartitionId',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 通过业务主体id获取网点
export const apiSiteQuery = (data, isBool = true) => {
  return request({
    method: 'GET',
    url: '/site/query/' + data,
    isLoading: isBool // 是否显示加载中参数
    // baseURL: baseURLAdmin
  });
};

// 查询服务商渠道
export const apiProviderChannel = (data, isBool = false) => {
  return newRequest({
    method: 'POST',
    url: '/common/providerChannel',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 账单核收分页查询
export const apiSiteReceiptGetPage = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/SiteReceipt/getPage',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};
/**
 * 查询对账单
 * @param code 收款单号
 * @param isBool 是否显示loading
 * @returns {*}
 */
export const getSiteBillNumber = (code, isBool = false) => {
  return newRequest({
    method: 'get',
    url: '/SiteReceipt/getSiteBillNumber/' + code,
    isLoading: isBool // 是否显示加载中参数
  });
};
// 获取客户账户详情
export const apiGetCustomerFinanceInfo = (data, isBool = true) => {
  return request({
    method: 'GET',
    url: '/customer/getCustomerFinanceInfo/' + data,
    isLoading: isBool // 是否显示加载中参数
  });
};
// 获取客户账户流水
export const apiCustomerReceiptPage = (data, isBool = true) => {
  return request({
    method: 'POST',
    url: '/fa/customerReceipt/page',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 导出客户账户流水
export const apiCustomerExportAccountStatement = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/customer/exportAccountStatement',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};
// 导出客户信息
export const apiCustomerExportAccountInfo = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/customer/exportAccountInfo',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};
// 应收客户账户编辑文件
export const apiSiteReceiptUpdateFile = (data) => {
  return newRequest({
    method: 'POST',
    url: '/SiteReceipt/updateAttachmentFile',
    data
  });
};
// ----------------- 财务基础资料-地区管理与税费 start -----------------

// 地区列表查询

export const apiAreaParentPage = (data, isBool = true) => {
  return newRequest({
    method: 'GET',
    url: '/area/getParentNodes',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

export const apiAreaPage = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/area/page',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 新增地区
export const apiAreaAdd = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/area/add',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 编辑地区
export const apiAreaEdit = (data, isBool = true) => {
  return newRequest({
    method: 'put',
    url: '/area/edit',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};
export const apiAreaCityEdit = (data, isBool = true) => {
  return newRequest({
    method: 'put',
    url: '/area/editCityInfo',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 删除地区
export const apiAreaDelete = (data, isBool = true) => {
  return newRequest({
    method: 'delete',
    url: '/area/delete/' + data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 导入添加地区
export const apiAreaImportAdd = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/area/importAdd',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 导出地区
export const apiAreaExport = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/area/export',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 获取icms税费匹配规则更改以及增加税费参照表
export const apiGetTaxationReferList = (data, isBool = true) => {
  return newRequest({
    method: 'post',
    url: '/taxationRefer/getTaxationReferList',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 编辑icms税费参照表
export const apiGetTaxationEdit = (data, isBool = true) => {
  return newRequest({
    method: 'post',
    url: '/taxationRefer/edit',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 导入icms税费
export const apiGetTaxationImport = (data, isBool = true) => {
  return newRequest({
    method: 'post',
    url: '/taxationRefer/importEdit',
    data,
    isLoading: isBool
  });
};

// 内河运输费分页查询
export const apiGetInlandTransportationFeePage = (data, isBool = true) => {
  return newRequest({
    method: 'post',
    url: '/hanoiTransportTaxRefer/page',
    data,
    isLoading: isBool
  });
};
// 新增内河运输费
export const apiGetInlandTransportationFeeAdd = (data, isBool = true) => {
  return newRequest({
    method: 'post',
    url: '/hanoiTransportTaxRefer/add',
    data,
    isLoading: isBool
  });
};
// 编辑内河运输费
export const apiGetInlandTransportationFeeEdit = (data, isBool = true) => {
  return newRequest({
    method: 'post',
    url: '/hanoiTransportTaxRefer/edit',
    data,
    isLoading: isBool
  });
};
// 删除内河运输费
export const apiGetInlandTransportationFeeDelete = (id, isBool = true) => {
  return newRequest({
    method: 'post',
    url: `/hanoiTransportTaxRefer/delete/${id}`,
    isLoading: isBool
  });
};
// 批量删除
export const apiGetInlandTransportationFeeBatchDelete = (data, isBool = true) => {
  return newRequest({
    method: 'post',
    url: '/hanoiTransportTaxRefer/batchDelete',
    data,
    isLoading: isBool
  });
};
// 导入内河运输费
export const apiGetInlandTransportationFeeImport = (data, isBool = true) => {
  return newRequest({
    method: 'post',
    url: '/hanoiTransportTaxRefer/importAdd',
    data,
    isLoading: isBool
  });
};
// 导出内河运输费
export const apiGetInlandTransportationFeeExport = (data, isBool = true) => {
  return newRequest({
    method: 'post',
    url: '/hanoiTransportTaxRefer/export',
    data,
    isLoading: isBool
  });
};

// ----------------- 财务基础资料-地区管理与税费 end -----------------

// 加盟商时效统计日期维度分页查询
export const apiProviderAgingPage = (data, isBool = true) => {
  return request({
    method: 'POST',
    url: '/report/site/timeValidity/page',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseURLAdmin
  });
};
// 加盟商时效统计汇总查询
export const apiProviderAgingSummary = (data, isBool = true) => {
  return request({
    method: 'POST',
    url: '/report/site/timeValidity/summary',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseURLAdmin
  });
};
// 加盟商时效统计日期维度导出
export const apiProviderAgingExportDateDimension = (data, isBool = true) => {
  return request({
    method: 'POST',
    url: '/report/site/timeValidity/export',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseURLAdmin
  });
};
// 加盟商时效统计汇总导出
export const apiProviderAgingExportSummary = (data, isBool = true) => {
  return request({
    method: 'POST',
    url: '/report/site/timeValidity/summary/export',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseURLAdmin
  });
};
// 应付账户导出账户信息
export const apiExportMeetSiteAccountInfo = (data, isBool = true) => {
  return newRequest({
    method: 'post',
    url: '/siteAccount/exportMeetSiteAccountInfo',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};
// 应付账户导出账户流水
export const apiExportOfBillFlow = (data, isBool = true) => {
  return newRequest({
    method: 'post',
    url: '/sitePayable/exportOfBillFlow',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};
// 应付账户详情
export const apiGetDetailPage = (data, isBool = true) => {
  return newRequest({
    method: 'post',
    url: '/sitePayable/getPage',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// ---------------- 应付-报价管理 start --------------------

// 应付报价管理分页查询
export const apiPayableOfferPriceQueryList = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/payableOfferPrice/queryList',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 应付报价管理方案详情
export const apiListByPayableOfferPriceId = (data, isBool = true) => {
  return newRequest({
    method: 'GET',
    url: '/payableOfferPriceDetail/listByPayableOfferPriceId/' + data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 应付费用报价管理启用、禁用
export const apiPayableOfferPriceSwitch = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/payableOfferPrice/switch?id=' + data.id + '&state=' + data.sw,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 应付报价管理添加报价方案
export const apiPayableOfferPriceDetailInsert = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/payableOfferPriceDetail/insert',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// DSP批量导入新增
export const apiPayableOfferPriceDetailBatchInsert = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/payableOfferPriceDetail/batchInsert',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 应付报价管理编辑报价方案
export const apiPayableOfferPriceDetailUpdate = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/payableOfferPriceDetail/update',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 应付报价管理报价操作日志
export const apiPayableOfferPriceOperateLog = (data, isBool = true) => {
  return newRequest({
    method: 'GET',
    url: '/payableOfferPriceOperateLog/listByPayableOfferPriceId/' + data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 应付报价管理导出
export const apiExportOfferPriceInfo = (data) => {
  return newRequest({
    method: 'POST',
    url: '/payableOfferPrice/exportOfferPriceInfo',
    data,
    baseURL: baseFinanceURL
  });
};

// 车型
export const apiGetCarLineList = () => {
  return newRequest({
    method: 'get',
    url: `/common/schedule/system/dict/data/type/bs_vehicle_model`,
    isLoading: false, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};
// 运输主体
export const apiOptionForSelect = (data) => {
  return newRequest({
    method: 'post',
    url: `/common/schedule/transportProvider/optionForSelect`,
    data,
    isLoading: false, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};
// 车线-调度系统来源
export const apiGetCarLineDispatchSystemList = (data) => {
  return newRequest({
    method: 'post',
    url: `/common/schedule/vehicleLineInfo/optionForSelect`,
    data,
    isLoading: false, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// ---------------- 应付-报价管理 end --------------------

// ---------------- 应付-距离参照表 start --------------------

// 获取派送参照分页列表
export const apiDispatchReferencePage = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/dispatchReference/page',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 添加派送参照
export const apiDispatchReferenceInsert = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/dispatchReference/insert',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 导入派送参照
export const apiDispatchReferenceImportAdd = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/dispatchReference/importAdd',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 导出派送参照
export const apiDispatchReferenceExportAll = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/dispatchReference/exportAll',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 派送参照编辑
export const apiDispatchReferenceUpdate = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/dispatchReference/update',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// 派送参照删除
export const apiDispatchReferenceDelete = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/dispatchReference/delete',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseFinanceURL
  });
};

// ---------------- 应付-距离参照表 end --------------------

// 账单核付分页查询
export const apiSitePayableGetPage = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/sitePayable/getPage',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 数据推送日志
export const apiExpressFeePushLog = (data) => {
  return newRequest({
    method: 'POST',
    data,
    url: '/expressFeePushLog/page',
    baseURL: baseFinanceURL
  });
};

// 网点时效统计-明细
export const siteWaybillDetail = (data) => {
  return request({
    method: 'POST',
    url: '/report/site/timeValidity/detail',
    data,
    baseURL: baseURLAdmin
  });
};
// 网点时效统计-明细导出
export const detailExport = (data) => {
  return request({
    method: 'POST',
    url: '/report/site/timeValidity/detailExport',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * @description 发票管理分页
 * @param data
 * @param isBool
 * @returns {*}
 */
export const logisticsInvoicePage = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/brCte/page',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

/**
 * @description 发票管理导出
 * @param data
 * @param isBool
 * @returns {*}
 */
export const logisticsInvoiceExport = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/brCte/export',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

/**
 * @description 发票管理重开发票
 * @param data
 * @param isBool
 * @returns {*}
 */
export const logisticsInvoiceReGenerateCte = (data, isBool = true) => {
  return request({
    method: 'POST',
    url: '/fa/logisticsInvoice/reGenerateCte',
    data,
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    isLoading: isBool // 是否显示加载中参数
  });
};

/**
 * @description 发票管理取消发票
 * @param data
 * @param isBool
 * @returns {*}
 */
export const logisticsInvoiceCancel = (data, isBool = true) => {
  return request({
    method: 'POST',
    url: '/fa/logisticsInvoice/cancel',
    data,
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    isLoading: isBool // 是否显示加载中参数
  });
};

/**
 * @description 获取发票链接
 * @param data
 * @param isBool
 * @returns {*}
 */
export const faBrCteLabel = (data, isBool = true) => {
  return request({
    method: 'POST',
    url: '/fa/brCte/label',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 批量添加费用 - 查询订单信息
export const apiGetClAndLgInfo = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/payableSiteExpense/getClAndLgInfo',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};
// // 运输干支线添加列表
// export const apiSiteExpenseGetClAndLgInfo = (data, isBool = true) => {
//   return newRequest({
//     method: 'POST',
//     url: '/payableTransportSiteExpense/getClAndLgInfo',
//     data,
//     isLoading: isBool // 是否显示加载中参数
//   });
// };
// 价格查询日志
export const apiCarlosRequestLogPage = (data) => {
  return newRequest({
    method: 'POST',
    url: '/carlosRequestLog/page',
    data,
    baseURL: baseFinanceURL,
    isLoading: true
  });
  // .post('/fa/carlosRequestLog/page', data);
};
// 遗失率监控  ==> 分页
export const lostMonitor = (data) => {
  return request.post('/report/site/lostMonitor', data);
};
// 遗失率监控  ==> 分页
export const getLostdictCodeType = () => {
  return request.get('/dictLang/dictCode/lostType');
};
export const lostMonitorDetail = (data) => {
  return request({
    method: 'POST',
    url: '/report/site/lostMonitor/detail',
    data
  });
};
export const lostMonitorDetailExport = (data) => {
  return request({
    method: 'POST',
    url: '/report/site/lostMonitor/detailExport',
    data
  });
};
export const lostMonitorExport = (data) => {
  return request({
    method: 'POST',
    url: '/report/site/lostMonitorExport',
    data
  });
};

// 新分拣规则操作日志
export const sortedRuleQueryLog = (data) => {
  // return request.post('/wms/sortedRule/queryLog', data);
  return newRequest({
    method: 'POST',
    url: '/wms/sortedRule/queryLog',
    data,
    baseURL: baseURLAdmin
  });
};
// 模糊查询操作对象
export const sortedRuleQueryLogObj = (data) => {
  // return request.post('/wms/sortedRule/queryLogObj', data);
  return newRequest({
    method: 'POST',
    url: '/wms/sortedRule/queryLogObj',
    data,
    baseURL: baseURLAdmin
  });
};
// 装卸车监控明细-明细
export const loadUnloadDetailed = (data) => {
  return request({
    method: 'POST',
    url: '/loadUnloadDetailed/loadMonitorPackageNumberQueryDetail',
    data,
    baseURL: baseURLAdmin
  });
};
// 装卸车监控明细-导出
export const loadUnloadDetailedExportAll = (data) => {
  return request({
    method: 'POST',
    url: '/loadUnloadDetailed/exportLoadMonitPackageNumberDetail',
    data,
    baseURL: baseURLAdmin
  });
};

// 导出账单文件
export const apiSitePayableGetFiles = (data) => {
  return request.post('/fa/sitePayable/getFiles', data);
};

// -------------------- 应付-揽收账户 start --------------------

// 揽收应付账户:
export const apiCollectionPayableAccountPage = (data) => {
  return newRequest({
    method: 'POST',
    url: '/collectionPayableAccount/page',
    data,
    baseURL: baseFinanceURL
  });
};

// 派送应付账户:
export const apiDeliveryPayableAccountPage = (data) => {
  // return request.post('/fa/deliveryPayableAccount/page', data);
  return newRequest({
    method: 'POST',
    url: '/deliveryPayableAccount/page',
    data,
    baseURL: baseFinanceURL
  });
};

// 揽收应付账户信息导出
export const apiCollectionPayableAccountExport = (data) => {
  return newRequest({
    method: 'POST',
    url: '/collectionPayableAccount/export',
    data,
    baseURL: baseFinanceURL
  });
};

// AJD派送应付账户信息导出
export const apiDeliveryPayableAccountExport = (data) => {
  return newRequest({
    method: 'POST',
    url: '/deliveryPayableAccount/export',
    data,
    baseURL: baseFinanceURL
  });
};
// DSP派送应付账户信息导出
export const apiDspDeliveryPayableAccountExport = (data) => {
  return newRequest({
    method: 'POST',
    url: '/deliveryPayableAccount/exportDsp',
    data,
    baseURL: baseFinanceURL
  });
};
// 发票管理分页
export const apiLogisticsInvoicePage = (data) => {
  // return request.post('/fa/logisticsInvoice/page', data);
  return newRequest({
    method: 'post',
    url: '/logisticsInvoice/page',
    data
  });
};

// 手动生成cte(手动开票)
export const apiLogisticsInvoiceGenerateCte = (data) => {
  return request.post('/fa/logisticsInvoice/generateCte', data);
};

// 取消开票
export const apiLogisticsInvoicecCancel = (data) => {
  return request.post('/fa/logisticsInvoice/cancel', data);
};

// 重开cte
export const apiLogisticsInvoiceReGenerateCte = (data) => {
  return request.post('/fa/logisticsInvoice/reGenerateCte', data);
};

// 发票下载
export const apiLogisticsInvoicecLabel = (data) => {
  return request.post('/fa/logisticsInvoice/label', data);
};

// 发票导出
export const apiLogisticsInvoicecExport = (data) => {
  return request.post('/fa/logisticsInvoice/export', data);
};

// 账单审核导出
export const apiSiteBillExport = (data) => {
  return newRequest({
    method: 'post',
    url: '/siteBill/export',
    data
  });
};

// 账单审核导出明细
export const apiSiteBillExportDetailed = (data) => {
  return newRequest({
    method: 'post',
    url: '/siteBill/exportDetailed',
    data
  });
};

// 账单审核导出明细
export const apiSiteReceiptExport = (data) => {
  return newRequest({
    method: 'post',
    url: '/SiteReceipt/export',
    data
  });
};

// 账单审核导出明细
export const apiSiteReceiptExportDetailed = (data) => {
  return request.post('/fa/SiteReceipt/exportDetailed', data);
};
// 袋数明细-明细
export const loadUnloadDetailedbagNumber = (data) => {
  return request({
    method: 'POST',
    url: '/loadUnloadDetailed/bagNumber/pageQuery',
    data,
    baseURL: baseURLAdmin
  });
};
export const loadUnloadDetailedbagexportAll = (data) => {
  return request({
    method: 'POST',
    url: '/loadUnloadDetailed/bagNumber/exportAll',
    data,
    baseURL: baseURLAdmin
  });
};

// ------------------------ 成本应付账户 start ------------------------

// 分页
export const apiCostPayableAccountPage = (data) => {
  return newRequest({
    method: 'POST',
    url: '/costPayableAccount/page',
    data
  });
};

// 账户导出
export const apiCostPayableAccountExport = (data) => {
  return newRequest({
    method: 'POST',
    url: '/costPayableAccount/export',
    data
  });
};

// 流水导出
export const apiSiteCostExportOfBillFlow = (data) => {
  return newRequest({
    method: 'POST',
    url: '/siteCost/exportOfBillFlow',
    data
  });
};

// -------------------- 成本应付账户 end ------------------------

// 新分拣规则操作日志
export const waybillCompartmentQuery = (data) => {
  // return request.post('/wms/sortedRule/queryLog', data);
  return newRequest({
    method: 'POST',
    url: '/sortedRecord/queryGridNumber',
    data,
    baseURL: baseURLAdmin
  });
};
// 格口数据清理-任务总数查询
export const queryDeleteSortedRecordCount = (data) => {
  return request({
    method: 'POST',
    url: '/wms/sortedRule/queryDeleteSortedRecordCount',
    data,
    baseURL: baseURLAdmin
  });
};
// 格口数据清理-格口数据清理
export const deleteSortedRecord = (data) => {
  return request({
    method: 'POST',
    url: '/wms/sortedRule/deleteSortedRecord',
    data,
    baseURL: baseURLAdmin
  });
};

// 财务查询车牌号
export const queryCarNumber = (data) => {
  return newRequest({
    method: 'POST',
    url: '/common/schedule/getVehicleInfo'
  });
};

// 查询司机
export const queryDriver = (data) => {
  return newRequest({
    method: 'POST',
    url: '/common/schedule/getDrivers'
  });
};

// 网点管理 - 分页
export const getSiteTreeWithTab = (data) => {
  return request({
    method: 'POST',
    url: '/site/getSiteTreeWithTab',
    data,
    baseURL: baseURLAdmin
  });
};
// 网点管理 - 邮编校验
export const validateZipCodeRange = (data) => {
  return request({
    method: 'POST',
    url: '/site/validateZipCodeRange',
    data,
    baseURL: baseURLAdmin
  });
};

// 调度字典数据
export const queryInsuranceType = (type) => {
  return newRequest({
    method: 'get',
    url: `/common/schedule/systemDict/${type}`
  });
};

// 应付州数据（sp）
export const queryState = () => {
  return newRequest({
    method: 'get',
    url: '/area/payable/twoCode'
  });
};

// 快递字典-渠道价
export const queryExpressChannelPrice = (data) => {
  return newRequest({
    method: 'post',
    url: '/rpc/dict/list',
    data
  });
};

// 快递字典-费用属性
export const queryExpressFeeProperty = (data) => {
  return newRequest({
    method: 'post',
    url: '/fee/listProperty',
    data
  });
};
